'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _utils = require('../../../utils');

var _common = require('../../common');

var _constants = require('../../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var toKey = _utils.FormattingUtils.toKey;
var renderDate = _utils.TableRenderingUtils.renderDate,
    renderFilenameLink = _utils.TableRenderingUtils.renderFilenameLink,
    renderFileType = _utils.TableRenderingUtils.renderFileType;
var PERMISSIONS = _constants.AppConstants.PERMISSIONS;
var LienDocuments = (_dec = (0, _mobxReact.inject)('CaseStore', 'LienStore', 'SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(LienDocuments, _Component);

  function LienDocuments() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LienDocuments);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LienDocuments.__proto__ || Object.getPrototypeOf(LienDocuments)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isUploading', _descriptor, _this), _initDefineProp(_this, 'uploadModalShowing', _descriptor2, _this), _this.currentDocument = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LienDocuments, [{
    key: 'handleDrop',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(files) {
        var SessionStore, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                SessionStore = this.props.SessionStore;


                this.isUploading.setTrue();

                _context.prev = 2;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 6;
                _iterator = files[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 15;
                  break;
                }

                file = _step.value;
                _context.next = 12;
                return this.uploadLienDocument({ file: file, name: file.name });

              case 12:
                _iteratorNormalCompletion = true;
                _context.next = 8;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](6);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                SessionStore.trackEvent('BULK_LIEN_DOCUMENT_UPLOAD', { file_count: files.length });
                _context.next = 35;
                break;

              case 32:
                _context.prev = 32;
                _context.t1 = _context['catch'](2);

                SessionStore.trackEvent('BULK_LIEN_DOCUMENT_UPLOAD_FAILURE', { file_count: files.length });

              case 35:
                _context.prev = 35;

                this.isUploading.setFalse();
                return _context.finish(35);

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 32, 35, 38], [6, 17, 21, 29], [22,, 24, 28]]);
      }));

      function handleDrop(_x) {
        return _ref2.apply(this, arguments);
      }

      return handleDrop;
    }()
  }, {
    key: 'handleSingleLienDocumentUpload',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.currentDocument) {
                  _context2.next = 7;
                  break;
                }

                this.isUploading.setTrue();
                _context2.next = 4;
                return this.uploadLienDocument(data);

              case 4:
                this.isUploading.setFalse();
                _context2.next = 8;
                break;

              case 7:
                this.handleDocumentEdit(data);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSingleLienDocumentUpload(_x2) {
        return _ref3.apply(this, arguments);
      }

      return handleSingleLienDocumentUpload;
    }()
  }, {
    key: 'uploadLienDocument',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var _props, CaseStore, LienStore, lien;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props = this.props, CaseStore = _props.CaseStore, LienStore = _props.LienStore, lien = _props.lien;
                _context3.next = 3;
                return LienStore.createLienDocument({ data: data, lienId: lien.id });

              case 3:
                CaseStore.fetchTabCounts(lien.case);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function uploadLienDocument(_x3) {
        return _ref4.apply(this, arguments);
      }

      return uploadLienDocument;
    }()
  }, {
    key: 'onEditDocument',
    value: function onEditDocument(documentData) {
      var lien = this.props.lien;

      this.currentDocument = (0, _find3.default)((0, _mobx.toJS)(lien.documents), { id: documentData.id });
      this.uploadModalShowing.setTrue();
    }
  }, {
    key: 'handleDocumentEdit',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(documentData) {
        var _props2, LienStore, lien;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _props2 = this.props, LienStore = _props2.LienStore, lien = _props2.lien;

                if (!documentData.id) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 4;
                return LienStore.updateLienDocument(documentData.id, documentData);

              case 4:
                this.currentDocument = null;
                _context4.next = 7;
                return LienStore.listLienDocuments(lien.id);

              case 7:
                this.documents = _context4.sent;

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleDocumentEdit(_x4) {
        return _ref5.apply(this, arguments);
      }

      return handleDocumentEdit;
    }()
  }, {
    key: 'getViewUrl',
    value: function getViewUrl(document) {
      var download_url = document.download_url,
          url = '' + download_url + toKey({ dl: 0 });


      return this.props.SessionStore.addAuthenticationToUrl(url);
    }
  }, {
    key: 'render',
    value: function render() {
      var documents = this.props.documents;


      return _react2.default.createElement(
        _Well2.default,
        null,
        _react2.default.createElement(
          'form',
          null,
          _react2.default.createElement(_common.DocumentTable, {
            columns: this.columns,
            documents: documents,
            dropzoneText: 'Drag lien documents here',
            onClickAddNew: this.uploadModalShowing.setTrue,
            onDrop: this.handleDrop,
            title: 'Lien Documents',
            isUploading: this.isUploading.isTrue
          }),
          this.uploadModalShowing.isTrue && _react2.default.createElement(_common.DocumentUploadModal, {
            _document: this.currentDocument,
            onClose: this.uploadModalShowing.setFalse,
            onSubmit: this.handleSingleLienDocumentUpload
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'columns',
    get: function get() {
      var _this2 = this;

      var SessionStore = this.props.SessionStore,
          hasEditPermission = SessionStore.userHasPermission(PERMISSIONS.EDIT_LIEN_DOCUMENTS);

      return [{
        accessor: 'file',
        Cell: renderFileType,
        className: 'col-file',
        Header: 'File Type',
        maxWidth: 20
      }, {
        accessor: 'name',
        Cell: renderFilenameLink,
        getViewUrl: this.getViewUrl,
        Header: 'Name',
        minWidth: 200
      }, {
        accessor: 'created_at',
        Cell: renderDate,
        className: 'col-date',
        Header: 'Date'
      }, {
        accessor: 'edit',
        Cell: function Cell(row) {
          return _react2.default.createElement(
            'div',
            null,
            hasEditPermission && _react2.default.createElement(
              _common.ActionButton,
              { className: 'btn-edit-type', data: row.original, onClick: _this2.onEditDocument },
              _react2.default.createElement(_common.Icon, { type: 'pencil' })
            )
          );
        },
        className: 'col-buttons',
        Header: 'actions',
        width: 30
      }, {
        accessor: 'download_url',
        Cell: function Cell(row) {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _common.ActionButton,
              { data: row.value, onClick: _this2.props.CaseStore.onDocumentDownloadClick },
              _react2.default.createElement(_common.Icon, { type: 'download' })
            )
          );
        },
        className: 'col-buttons',
        Header: 'actions',
        width: 30
      }];
    }
  }]);

  return LienDocuments;
}(_react.Component), _class3.propTypes = {
  CaseStore: _propTypes2.default.object.isRequired,
  documents: _propTypes2.default.array,
  lien: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isUploading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool(false);
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'uploadModalShowing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool(false);
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'handleDrop', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleDrop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSingleLienDocumentUpload', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleSingleLienDocumentUpload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onEditDocument', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onEditDocument'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleDocumentEdit', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleDocumentEdit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = LienDocuments;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(toKey, 'toKey', '/app/src/components/page-case/main-fundings/LienDocuments.js');
  reactHotLoader.register(renderDate, 'renderDate', '/app/src/components/page-case/main-fundings/LienDocuments.js');
  reactHotLoader.register(renderFilenameLink, 'renderFilenameLink', '/app/src/components/page-case/main-fundings/LienDocuments.js');
  reactHotLoader.register(renderFileType, 'renderFileType', '/app/src/components/page-case/main-fundings/LienDocuments.js');
  reactHotLoader.register(PERMISSIONS, 'PERMISSIONS', '/app/src/components/page-case/main-fundings/LienDocuments.js');
  reactHotLoader.register(LienDocuments, 'LienDocuments', '/app/src/components/page-case/main-fundings/LienDocuments.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-fundings/LienDocuments.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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